import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';

const styles = theme => ({
  root: {
    position: 'fixed',
    top: 64,
    left: 132,
    right: 0,
    padding: '16px 16px 0',
    zIndex: 1100,
    minWidth: 1040,
    backgroundColor: theme.palette.grey['100'],
    transition: theme.transitions.create(['left'], {
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.down('sm')]: {
      left: 48,
      minWidth: 0,
      right: 'auto',
      width: 'calc(100% - 16px)',
      padding: '8px 8px 0',
    },
  },
  rootMainNavigationCollapsed: {
    left: 48,
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  rootDisableGutters: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
});

const StickyToolbar = ({
  className,
  children,
  disableGutters,
  width,
  classes,
  ...otherProps
}) => {
  let mainNavigationExpanded = true;
  if (otherProps.mainNavigationExpanded === undefined) {
    if (['xl', 'lg'].indexOf(width) !== -1) {
      mainNavigationExpanded = true;
    } else {
      mainNavigationExpanded = false;
    }
  } else {
    mainNavigationExpanded = otherProps.mainNavigationExpanded;
  }
  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootMainNavigationCollapsed]: !mainNavigationExpanded,
        [classes.rootDisableGutters]: disableGutters,
      })}
    >
      {children}
    </div>
  );
};

StickyToolbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disableGutters: PropTypes.bool,
  mainNavigationExpanded: PropTypes.bool,
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootMainNavigationCollapsed: PropTypes.string.isRequired,
    rootDisableGutters: PropTypes.string.isRequired,
  }).isRequired,
};

StickyToolbar.defaultProps = {
  className: '',
  disableGutters: false,
  mainNavigationExpanded: undefined,
};

const mapStateToProps = store => ({
  mainNavigationExpanded: store.routerParams.mainNavigationExpanded,
});

export default connect(mapStateToProps)(
  withWidth()(withStyles(styles)(StickyToolbar)),
);



// WEBPACK FOOTER //
// ./src/components/common/StickyToolbar.js